var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('div',[_c('apexchart',{attrs:{"width":_vm.width,"height":_vm.height,"options":Object.assign({}, _vm.chartOptions, {labels: _vm.chartMapping('name')}),"series":_vm.chartMapping('values')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }